import { render } from "./IconCurrencyExchange.vue?vue&type=template&id=3b5dd61c"
import script from "./IconCurrencyExchange.vue?vue&type=script&lang=js"
export * from "./IconCurrencyExchange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconCurrencyExchange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b5dd61c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b5dd61c', __exports__)) {
    api.reload('3b5dd61c', __exports__)
  }
  
  module.hot.accept("./IconCurrencyExchange.vue?vue&type=template&id=3b5dd61c", () => {
    api.rerender('3b5dd61c', render)
  })

}


export default __exports__